import React, { useState } from "react";
import { Search, Trash2, Edit, HelpCircle } from "lucide-react"; // npm install lucide-react

const ProductTags = () => {
  const [search, setSearch] = useState("");
  const [tagName, setTagName] = useState("");

  const tags = [
    { id: 1, name: "awesome", products: 18 },
    { id: 2, name: "cool", products: 18 },
    { id: 3, name: "computer", products: 14 },
    { id: 4, name: "apparel", products: 9 },
    { id: 5, name: "compact", products: 7 },
    { id: 6, name: "cell", products: 4 },
    { id: 7, name: "nice", products: 4 },
    { id: 8, name: "book", products: 3 },
    { id: 9, name: "camera", products: 3 },
  ];

  const filtered = tags.filter(
    (t) =>
      t.name.toLowerCase().includes(search.toLowerCase()) &&
      t.name.toLowerCase().includes(tagName.toLowerCase())
  );

  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      {/* Header */}
      <h1 className="text-2xl md:text-3xl font-semibold mb-4">Product tags</h1>

      {/* Delete Selected Button */}
      <div className="flex justify-end mb-4">
        <button className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md shadow">
          <Trash2 size={18} /> Delete selected
        </button>
      </div>

      {/* Search and Tag Filter */}
      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          {/* Search bar */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg overflow-hidden">
            <Search className="text-gray-500 mx-3" size={18} />
            <input
              type="text"
              placeholder="Search"
              className="w-full py-2 px-2 outline-none"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Tag name filter */}
          <div className="flex flex-col md:flex-row md:items-center gap-2">
            <label className="text-gray-700 font-medium flex items-center gap-1">
              Tag name
              <HelpCircle size={16} className="text-gray-400" />
            </label>
            <input
              type="text"
              placeholder="Enter tag name"
              className="border border-gray-300 rounded-lg px-3 py-2 outline-none w-full md:w-64"
              value={tagName}
              onChange={(e) => setTagName(e.target.value)}
            />
          </div>

          {/* Search button */}
          <button className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md shadow">
            <Search size={18} /> Search
          </button>
        </div>
      </div>

      {/* Table View (Desktop) */}
      <div className="bg-white rounded-lg shadow overflow-x-auto hidden md:block">
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3 border-b">
                <input type="checkbox" />
              </th>
              <th className="p-3 border-b">Tag name</th>
              <th className="p-3 border-b">Tagged products</th>
              <th className="p-3 border-b">Edit</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((t) => (
              <tr
                key={t.id}
                className="border-b hover:bg-gray-50 transition-colors"
              >
                <td className="p-3">
                  <input type="checkbox" />
                </td>
                <td className="p-3 text-gray-800">{t.name}</td>
                <td className="p-3">{t.products}</td>
                <td className="p-3">
                  <button className="flex items-center gap-1 text-gray-700 hover:text-blue-600">
                    <Edit size={16} /> Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View */}
      <div className="block md:hidden">
        {filtered.map((t) => (
          <div
            key={t.id}
            className="border rounded-lg mb-3 p-3 bg-gray-50 shadow-sm"
          >
            <div className="flex justify-between items-center mb-1">
              <h2 className="font-semibold text-gray-800">{t.name}</h2>
              <input type="checkbox" />
            </div>
            <p className="text-sm text-gray-700 mb-2">
              Tagged products: <span className="font-semibold">{t.products}</span>
            </p>
            <button className="flex items-center gap-1 text-blue-600 text-sm">
              <Edit size={14} /> Edit
            </button>
          </div>
        ))}
      </div>

      <p className="text-sm text-gray-500 mt-4">
        Learn more about{" "}
        <a href="#" className="text-blue-600 underline">
          product tags
        </a>
      </p>
    </div>
  );
};

export default ProductTags;
